import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '../components/Layout/index'
import Header from '../modules/Header'
import Footer from '../modules/Footer'
import NewsPage from '../components/NewsPage'
import SEO from '../components/seo'
import messages from '../messages/pageTitles.lang'
import metaDescription from '../messages/pageMetaDescriptions.lang'

const Newsroom = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsRoom)}
        description={formatMessage(metaDescription.NewsRoomDescription)}
        lang={locale}
      />
      <NewsPage />
    </Layout>
  )
}

export default Newsroom
